import React, { useState } from "react";
import QuestionStepperHeader from "./QuestionStepperHeader";
import { forwardRef, useImperativeHandle } from "react";
import { Divider } from "primereact/divider";

type QuestionStepperProps = {
    children?: React.ReactNode;
    style?: React.CSSProperties;
    className?: string;
    title: string;
    description: string;
    logo: string | null;
}

export type QuestionStepperRef = {
    nextStep: () => void;
    prevStep: () => void;
    setLastStep: () => void;
    setStep: (step: number) => void;
}

const QuestionStepper = forwardRef<QuestionStepperRef, QuestionStepperProps>(({ children, style, className, title, description, logo }, ref) => {

    const totalChildren = React.Children.toArray(children).length;
    const [position, setPosition] = useState((children?.valueOf) ? 1 : 0);

    useImperativeHandle(ref, () => ({
        nextStep: () => {
            if(position === totalChildren)
                return;
            setPosition(position + 1);
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
        prevStep: () => {
            if(position <= 1)
                return;
            setPosition(position - 1);
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
        setLastStep: () => {
            setPosition(totalChildren);
        },
        setStep: (step: number) => {
            if(step < 0 || step > totalChildren){
                setPosition(1);
                return;
            }
            setPosition(step + 1);
             window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }));

    const showCurrentStep = () => {
        if(!children?.valueOf)
            return (<div></div>);

        return React.Children.toArray(children)[position - 1];
    }
    
    return (
        <div style={style}>
            <QuestionStepperHeader title={title} logo={logo} description={description} headerName={`Página ${position}`} totalQuestions={totalChildren} position={position}/>
            {showCurrentStep()}
        </div>
    );
})

export default QuestionStepper;